<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <settings-control></settings-control>
      <settings-view></settings-view>
    </v-layout>
  </v-container>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import SettingsControl from '@/modules/settings/settingsControl'
import SettingsView from '@/modules/settings/settingsView'
export default {
  components: {
    SettingsControl,
    SettingsView,
  },
}
</script>

<style>
</style>
